import {CustomRequestStatus} from "@/constants/request/CustomRequestConstants";

export interface CustomRequestDTO {
    id: number;
    status: CustomRequestStatus
    title: string;
    description: string;
    assigneeId: number;
    assigneeName: string;
    createdById: number;
    createdByName: string;
    expirationDate: Date;
    comments: CustomRequestCommentDTO[]
}

export class CustomRequestCommentDTO{
    comment!: string;
    leftById!: number;
    leftByName!: string;
    createDate!: Date;
}

export class UpdateCustomRequestDTO{
    status!: CustomRequestStatus;
}